import React, {useEffect} from "react";
import AccordionGroup from "../../molecules/accordionGroup/accordionGroup";
import {IconSource} from "../../../shared/enums/iconSource";
import EventCategory from "../../../stores/domainStore/pages/models/eventCategory";
import Tag from "../../atoms/tag/tag";
import classNames from "classnames";
import "./eventCategoryAccordion.sass";
import EventSummary from "../../molecules/eventSummary/eventSummary";
import {format} from "date-fns";
import {EventClickArg} from "@fullcalendar/common";
import {useTranslation} from "react-i18next";
import {useStores} from "../../../stores/useStores";
import {runInAction} from "mobx";
import {calendarViewCategory} from "../../../shared/constants";
import {observer} from "mobx-react-lite";

export interface EventCategoryAccordionProps {
  eventCategories: EventCategory[];
  onEventClick: (info: EventClickArg) => void;
  calendarScheduleStartDate?: Date;
}
const EventCategoryAccordion: React.FC<EventCategoryAccordionProps> = ({
  eventCategories,
  onEventClick,
  calendarScheduleStartDate
}) => {
  const {
    uiStore: {eventsUiStore}
  } = useStores();
  const {t} = useTranslation(["event"]);

  const setAccordionRecord = (id: string, isExpanded: boolean) => {
    runInAction(() => {
      eventsUiStore.accordionRecords[calendarViewCategory] = accordions.reduce(
        (acc, category) => {
          acc = {
            ...acc,
            [category.id]: id === category.id ? isExpanded : false
          };
          return acc;
        },
        {} as {[key: string]: boolean}
      );
    });
  };

  useEffect(() => {
    //Close all accordions
    return () => {
      runInAction(
        () => (eventsUiStore.accordionRecords[calendarViewCategory] = {})
      );
    };
  }, []);

  const accordions = eventCategories.map((eventCategory) => ({
    id: eventCategory.id,
    header: (isExpanded: boolean) => (
      <div className={classNames("name", {expanded: isExpanded})}>
        <div>{eventCategory.name}</div>
        <Tag
          text={eventCategory.events?.length.toString() ?? "0"}
          type={isExpanded ? "system" : "neutral"}
        ></Tag>
      </div>
    ),
    children: eventCategory.events?.length ? (
      eventCategory.events?.map((event) => {
        // This structure is required to process the event by the handler in the eventsCalendarTemplate component.
        const info = {event} as any;
        return (
          <div
            className="event"
            key={`${event.id}_${event.extendedProps.eventStartDateTimeOffSet}`}
          >
            <div className="date">
              <div>{event.start.getDate()}</div>
              <div>{format(event.start, "EEE")}</div>
            </div>
            <div onClick={() => onEventClick(info)} className="event-summary">
              <EventSummary
                data={event}
                calendarScheduleStartDate={calendarScheduleStartDate}
              />
            </div>
          </div>
        );
      })
    ) : (
      <div className="no-events">{t("event:labels.noEvents")}</div>
    ),
    toggleIcon: IconSource.angleUp,
    isExpanded:
      eventsUiStore.accordionRecords[calendarViewCategory][eventCategory.id],
    onAccordionClick: (id: string, isExpanded: boolean) => {
      setAccordionRecord(id, isExpanded);
    }
  }));

  return (
    <div className="event-category-accordion">
      {!!accordions.length && (
        <AccordionGroup accordions={accordions}></AccordionGroup>
      )}
    </div>
  );
};

export default observer(EventCategoryAccordion);
